// src/App.tsx
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, Suspense, lazy } from "react";

// i18n
import "./i18n";

// Ana sayfa - hemen yükleniyor (ilk giriş noktası, code-split etmenin faydası yok)
import LandingPage from "./pages/LandingPage";
import WhatsAppButton from "./components/WhatsAppButton";

// Diğer tüm sayfalar - lazy load: kullanıcı o rotaya gitmeden JS indirilmez
const PriceList = lazy(() => import("./pages/PriceList"));
const Contact = lazy(() => import("./pages/Contact"));
const Staff = lazy(() => import("./pages/Staff"));
const About = lazy(() => import("./pages/About"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));

// Hizmet Detay Sayfaları
const ImplantPage = lazy(() => import("./pages/ImplantPage"));
const EstetikPage = lazy(() => import("./pages/EstetikPage"));
const KanalPage = lazy(() => import("./pages/KanalPage"));
const BeyazlatmaPage = lazy(() => import("./pages/BeyazlatmaPage"));
const CocukPage = lazy(() => import("./pages/CocukPage"));
const DisTeliPage = lazy(() => import("./pages/DisTeliPage"));
const DisEtiPage = lazy(() => import("./pages/DisEtiPage"));
const OrtodontiPage = lazy(() => import("./pages/OrtodontiPage"));
const BruksizmPage = lazy(() => import("./pages/BruksizmPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

// GA4 Sayfa Görüntüleme Hook'u
const GA4Tracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if ((window as any).gtag) {
      (window as any).gtag('config', 'G-1DF3BKCYY9', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>

      {/* GA4 sayfa takibi */}
      <GA4Tracker />

      <Suspense fallback={null}>
        <Routes>
          {/* Ana sayfalar */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/fiyat-listesi" element={<PriceList />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/kadromuz" element={<Staff />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />

          {/* Hizmet detay sayfaları */}
          <Route path="/implant" element={<ImplantPage />} />
          <Route path="/estetik-dis" element={<EstetikPage />} />
          <Route path="/kanal" element={<KanalPage />} />
          <Route path="/dis-beyazlatma" element={<BeyazlatmaPage />} />
          <Route path="/cocuk-dis" element={<CocukPage />} />
          <Route path="/dis-teli" element={<DisTeliPage />} />
          <Route path="/dis-eti" element={<DisEtiPage />} />
          <Route path="/ortodonti" element={<OrtodontiPage />} />
          <Route path="/bruksizm" element={<BruksizmPage />} />

          {/* Tanımsız rota - blank white page yerine markalı 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>

      {/* WhatsApp butonu */}
      <WhatsAppButton />
    </Router>
  );
}

export default App;
